class GroupRequestDTO {
    constructor({ name, taxId }) {
        this.name = name;
        this.taxId = taxId;
    }
};

export default GroupRequestDTO;